/* eslint-disable no-console */
import { ApolloLink } from '@apollo/client';
import { IS_TEST, IS_PRODUCTION } from '~/utils/constants';
import { logging } from './for-warbler';

// copied from https://github.com/blackxored/apollo-link-logger to make compatible with apollo client v3

const formatMessage = (operationType, operation, ellapsed) => {
  const headerCss = [
    `color: ${operationType === 'query' ? '#03A9F4' : 'red'};`, // operationType
    'color: inherit;', // operationName
  ];

  const parts = [`%c${operationType}`, `%c${operation.operationName}`];

  parts.push(`%c(in ${ellapsed} ms)`);
  headerCss.push('color: gray; font-weight: lighter;'); // time

  return [parts.join(' '), ...headerCss];
};

export const loggerLink = new ApolloLink((operation, forward) => {
  if (IS_TEST || IS_PRODUCTION) return forward(operation);

  const startTime = new Date().getTime();
  return forward(operation).map(result => {
    const operationType = (operation.query.definitions[0] as any).operation;
    const ellapsed = new Date().getTime() - startTime;

    const group = formatMessage(operationType, operation, ellapsed);

    logging.groupCollapsed(...group);

    logging.log('variables:', operation.variables);
    logging.log('result', result.data);

    logging.groupEnd(...group);
    return result;
  });
});
